import { render, staticRenderFns } from "./GlobalSideBar.vue?vue&type=template&id=aa151ed8&scoped=true"
import script from "./GlobalSideBar.vue?vue&type=script&lang=js"
export * from "./GlobalSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa151ed8",
  null
  
)

export default component.exports